var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.workflowViewers),function(viewer){return _c('viewer',{key:viewer.user,attrs:{"viewer":viewer}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }